/**
 * not-found.tsx — 404 page
 */

import { Link } from 'react-router-dom';

export default function NotFoundPage(): React.ReactElement {
  return (
    <div className="flex min-h-dvh items-center justify-center bg-surface-raised p-6">
      <div className="text-center max-w-sm">
        <div className="text-8xl font-black text-border mb-4" aria-hidden="true">404</div>
        <h1 className="text-2xl font-bold text-text-primary mb-2">Página no encontrada</h1>
        <p className="text-text-secondary mb-8">
          La página que buscas no existe o no tienes acceso a ella.
        </p>
        <Link to="/" className="kapi-btn-primary">
          Ir al dashboard
        </Link>
      </div>
    </div>
  );
}
